import Placeholder from "@/components/Placeholder";
import { CalendarClock } from "lucide-react";

const upcoming = [
  {
    id: "elite-carnival",
    name: "Elite Carnival",
    tagline: "Where Every Moment Becomes a Celebration.",
    date: "Coming Soon",
    desc: "A vibrant festival filled with entertainment, live performances, exciting games, delicious food, shopping and unforgettable experiences for all ages. Elite Carnival brings families, friends, and communities together in a celebration of joy, laughter and lasting memories.",
  },
  {
    id: "holi",
    name: "Elite Holi Fest",
    tagline: "Celebrate Every Colour. Live Every Moment.",
    date: "Coming Soon",
    desc: "An electrifying Holi celebration featuring live DJs, organic colours, rain dance, festive food and an unmatched atmosphere of music, energy and togetherness. Elite Holi Fest is where every splash of colour creates a memory you'll cherish forever.",
  },
];

export default function Upcoming() {
  return (
    <section id="upcoming" data-testid="upcoming-section" className="section">
      <div className="max-w-7xl mx-auto">
        <div className="text-center fade-up max-w-2xl mx-auto">
          <div className="eyebrow justify-center mb-4">Also On The Calendar</div>
          <h2 className="section-title">
            Other <span className="gold-text-gradient italic">upcoming events</span>
          </h2>
          <p className="mt-4 text-neutral-400">
            {/* Short dash used for the event teaser copy to make it feel cleaner. */}
            Save the dates – more information drops closer to each event.
          </p>
        </div>

        <div className="mt-14 grid md:grid-cols-2 gap-6">
          {upcoming.map((e) => (
            <article
              key={e.id}
              data-testid={`upcoming-${e.id}`}
              className="glass rounded-3xl p-6 card-hover flex flex-col"
            >
              {e.id === "elite-carnival" ? (
                <div className="relative w-full overflow-hidden rounded-2xl border border-[var(--ee-border)] bg-black" style={{ aspectRatio: "4/5" }}>
                  <img
                    data-testid="elite-carnival-poster"
                    src="/upcoming/elite-carnival/elite%20carnival%20poster.png"
                    alt="Elite Carnival poster"
                    loading="lazy"
                    className="absolute inset-0 w-full h-full object-contain"
                    draggable={false}
                  />
                </div>
              ) : e.id === "holi" ? (
                <div className="relative w-full overflow-hidden rounded-2xl border border-[var(--ee-border)] bg-black" style={{ aspectRatio: "4/5" }}>
                  <img
                    data-testid="elite-holi-poster"
                    src="/upcoming/elite-holi/elite-holi-poster.png"
                    alt="Elite Holi Fest poster"
                    loading="lazy"
                    className="absolute inset-0 w-full h-full object-contain"
                    draggable={false}
                  />
                </div>
              ) : (
                <Placeholder
                  testId={`${e.id}-poster`}
                  note={`${e.name.toUpperCase()} POSTER (portrait 4/5)`}
                  aspect="4/5"
                  className="w-full"
                />
              )}
              <div className="mt-6">
                <div className="flex items-center gap-2 text-[var(--ee-gold)] text-xs tracking-[0.28em] uppercase">
                  <CalendarClock size={14} /> {e.date}
                </div>
                <h3 className="font-display text-3xl mt-2">{e.name}</h3>
                <p className="mt-1 text-neutral-400 text-sm italic">
                  {e.tagline}
                </p>
                <p className="mt-4 text-sm text-neutral-300 leading-relaxed">
                  {e.desc}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
